import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { UserInfoDialogProps } from "../models/types";

const UserInfoDialog: React.FC<UserInfoDialogProps> = ({
  dialogTitle,
  dialogDescription,
  buttonText,
  formFieldLabel,
  formFieldName,
  onSubmit,
  open,
  handleClose,
  formType,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            onSubmit(formJson);
            handleClose();
          },
        }}
        sx={{ "& .MuiDialog-paper": { padding: "50px", boxShadow: "rbga(0, 0, 0, 0.5)" } }}
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogDescription}</DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id={formFieldName}
            name={formFieldName}
            label={formFieldLabel}
            type={formType}
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default UserInfoDialog;
